// extracted by mini-css-extract-plugin
export default {"pagina_conteudo":"NovoUsuario_pagina_conteudo__HmPB4"};